import type Charger from '@/classes/charger_classes/charger'
import type NetworkBranding from '@/classes/charger_classes/networkBranding'

/**
 * Given a charger and a list of network branding objects, returns the network branding object that matches the charger's operator name.
 * If no matching branding is found, returns undefined.
 * @param {Charger} charger the charger object to be queried.
 * @param {NetworkBranding[]} networks the list of network branding objects to be searched.
 * @returns {NetworkBranding | undefined} the matching network branding object, or undefined if none is found.
 */
export function findChargersNetworkBranding(charger: Charger, networks: NetworkBranding[]): NetworkBranding | undefined {
  const network = charger.operator?.name
  if (!network) return
  return networks.find((branding) => branding.isThisNetwork(network))
}
